import React from "react";
import SingleResult from "./SingleResult";
import NoResult from "./NoResult";
import ApproxResultWarning from "./ApproxResultWarning";

function FillResults({ fillData }) {
  console.log(fillData);
  if (fillData.matchType === "noMatch") {
    return <NoResult fillData={fillData} />;
  }
  const makeMultipleSingleResults = (fillData) => {
    return Object.keys(fillData).reduce((acc, cur) => {
      if (cur === "matchType") {
        return acc;
      } else {
        return [...acc, <SingleResult key={cur} fillData={fillData[cur]} />];
      }
    }, []);
  };
  const results = makeMultipleSingleResults(fillData);
  console.log("results ", results);
  return (
    <div className="mt-5">
      {fillData.matchType === "approx" ? (
        <ApproxResultWarning approxResults={results} />
      ) : (
        <div></div>
      )}
      {results}
    </div>
  );
}

export default FillResults;
